import { type SearchFilters } from '@/typings/twitter_benchmark_campaign_posts'

const countRange = (min: number | undefined, max: number | undefined): number =>
  min !== undefined || max !== undefined ? 1 : 0

const APPLIED_FILTER_ITEMS: {
  label: string
  count: (filters: SearchFilters) => number
}[] = [
  { label: 'アカウント', count: filters => filters.accountIds?.length ?? 0 },
  { label: 'フォロワー数', count: filters => countRange(filters.followersMin, filters.followersMax) },
  { label: '業界', count: filters => filters.industryIds?.length ?? 0 },
  { label: 'タグ', count: filters => filters.tags?.length ?? 0 },
  { label: '投稿内容', count: filters => (filters.keyword ? 1 : 0) },
  { label: 'キャンペーン形式', count: filters => filters.campaignTypes?.length ?? 0 },
  { label: 'インセンティブ', count: filters => filters.incentives?.length ?? 0 },
  {
    label: '当選人数',
    count: filters => (filters.winnerCountUndetectable ? 1 : countRange(filters.winnerCountMin, filters.winnerCountMax))
  },
  { label: 'トレンド実績', count: filters => (filters.isTrend !== undefined ? 1 : 0) },
  { label: '開催日数', count: filters => countRange(filters.campaignDaysMin, filters.campaignDaysMax) },
  {
    label: 'インプレッション',
    count: filters => countRange(filters.impressionsCountMin, filters.impressionsCountMax)
  },
  { label: 'いいね', count: filters => countRange(filters.likesCountMin, filters.likesCountMax) },
  { label: 'リポスト', count: filters => countRange(filters.retweetsCountMin, filters.retweetsCountMax) },
  { label: '引用数', count: filters => countRange(filters.quotesCountMin, filters.quotesCountMax) },
  { label: '返信数', count: filters => countRange(filters.repliesCountMin, filters.repliesCountMax) },
  { label: '反応数', count: filters => countRange(filters.reactionsCountMin, filters.reactionsCountMax) },
  { label: '反応率', count: filters => countRange(filters.reactionsRateMin, filters.reactionsRateMax) }
]

/**
 * 検索条件のうち値が入っている項目のラベル一覧を返す純関数。
 */
export function getAppliedFilterLabels(filters: SearchFilters | undefined): string[] {
  if (!filters) return []
  return APPLIED_FILTER_ITEMS.filter(({ count }) => count(filters) > 0).map(({ label }) => label)
}

/**
 * 適用中の検索条件の値の総数を返す純関数。（Min/Max 範囲は、1として数える）
 */
export function countAppliedFilterValues(filters: SearchFilters | undefined): number {
  if (!filters) return 0
  return APPLIED_FILTER_ITEMS.reduce((sum, { count }) => sum + count(filters), 0)
}

/**
 * タブタイトルに追記する括弧部分を組み立てる（例: `（アカウント | 返信数）`）。
 */
export function formatAppliedFilterSuffix(filters: SearchFilters | undefined): string {
  const labels = getAppliedFilterLabels(filters)
  return labels.length ? `（${labels.join(' | ')}）` : ''
}
